export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const BASE_URL = API_URL.replace(/\/api\/?$/, '');
